import { FACILITY_TYPES } from './index';

const FacilityTypeCategoryCodes = {};

FacilityTypeCategoryCodes[FACILITY_TYPES.Hospital] = [97, 605, 835, 881, 898, 904];
FacilityTypeCategoryCodes[FACILITY_TYPES.FreeStandingSurgeryCenter] = [10];
FacilityTypeCategoryCodes[FACILITY_TYPES.FreeStandingRadiologyFacility] = [161, 262, 528, 629, 755];
FacilityTypeCategoryCodes[FACILITY_TYPES.FreeStandingLab] = [129, 406, 889, 897];
FacilityTypeCategoryCodes[FACILITY_TYPES.Clinic] = [
    0, 1, 4, 5, 11, 12, 13, 18, 19, 29, 33, 34, 35, 42, 43, 44, 49, 56, 60, 62, 63, 65, 66, 68, 72,
    75, 76, 85, 86, 87, 88, 90, 91, 94, 96, 98, 100, 103, 104, 105, 108, 109, 113, 127, 137, 138,
    139, 141, 151, 153, 165, 168, 169, 170, 172, 173, 177, 178, 180, 181, 182, 183, 184, 185, 187,
    189, 191, 192, 195, 196, 198, 199, 200, 201, 203, 204, 205, 207, 208, 209, 210, 211, 212, 214,
    215, 216, 221, 222, 223, 224, 225, 226, 227, 229, 231, 232, 233, 234, 235, 239, 240, 244, 246,
    248, 249, 250, 256, 257, 261, 264, 265, 267, 271, 279, 281, 282, 283, 285, 286, 287, 289, 290,
    291, 295, 298, 299, 301, 389, 393, 394, 396, 402, 439, 442, 443, 444, 445, 446, 449, 460, 489,
    611, 626, 677, 691, 699, 725, 887, 888, 890, 891, 892, 893, 894, 895, 896, 899, 900, 902, 903,
    905, 906, 907,
];

const findBySpecialtyIds = (specialtyCode) => {
    if (FacilityTypeCategoryCodes[FACILITY_TYPES.Hospital].includes(specialtyCode)) {
        return FACILITY_TYPES.Hospital;
    } else if (
        FacilityTypeCategoryCodes[FACILITY_TYPES.FreeStandingSurgeryCenter].includes(specialtyCode)
    ) {
        return FACILITY_TYPES.FreeStandingSurgeryCenter;
    } else if (
        FacilityTypeCategoryCodes[FACILITY_TYPES.FreeStandingRadiologyFacility].includes(
            specialtyCode
        )
    ) {
        return FACILITY_TYPES.FreeStandingRadiologyFacility;
    } else if (FacilityTypeCategoryCodes[FACILITY_TYPES.FreeStandingLab].includes(specialtyCode)) {
        return FACILITY_TYPES.FreeStandingLab;
    } else if (FacilityTypeCategoryCodes[FACILITY_TYPES.Clinic].includes(specialtyCode)) {
        return FACILITY_TYPES.Clinic;
    } else {
        return null;
    }
};

export default findBySpecialtyIds;
